var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiw1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 174,
    viewBox: "0 0 280 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 279,
    height: 173,
    rx: 12.5,
    fill: "white",
    stroke: "#2B2BCB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 23.5,
    width: 127,
    height: 125.458,
    rx: 12.5,
    fill: "#F8F6FA",
    stroke: "#2B2BCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.409 99.2132H151.592C154.391 99.2132 155.797 97.7771 155.797 94.9321V78.0673C155.797 75.2222 154.391 73.7861 151.592 73.7861H128.409C125.623 73.7867 124.203 75.2093 124.203 78.0673V94.9327C124.203 97.7913 125.623 99.2132 128.409 99.2132ZM146.449 86.4658C145.846 85.9136 145.163 85.6231 144.44 85.6231C143.69 85.6231 143.033 85.8859 142.417 86.4522L136.364 92.0322L133.887 89.7116C133.324 89.2007 132.721 88.9243 132.079 88.9243C131.489 88.9243 130.913 89.1871 130.364 89.698L126.36 93.4123V78.1793C126.36 76.7426 127.109 76.0107 128.449 76.0107H151.552C152.877 76.0107 153.641 76.7426 153.641 78.1793V93.427L146.449 86.4658ZM134.181 86.6178C135.909 86.6178 137.328 85.154 137.328 83.3585C137.328 81.5771 135.909 80.0992 134.181 80.0992C132.44 80.0992 131.021 81.5771 131.021 83.3585C131.022 84.2224 131.356 85.0505 131.948 85.6614C132.54 86.2724 133.343 86.6163 134.181 86.6178Z",
    fill: "#2B2BCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiw1);
export default __webpack_public_path__ + "static/media/HIW-1.8c0ca78aaea6ee96804d8fad63c99461.svg";
export { ForwardRef as ReactComponent };